import { render, staticRenderFns } from "./ProposalParticipantItem.vue?vue&type=template&id=170923f8&scoped=true"
import script from "./ProposalParticipantItem.vue?vue&type=script&lang=ts"
export * from "./ProposalParticipantItem.vue?vue&type=script&lang=ts"
import style0 from "./ProposalParticipantItem.vue?vue&type=style&index=0&id=170923f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170923f8",
  null
  
)

export default component.exports